export const worksheetsTestPrep = [
  // ACT Math Prep
  {
    id: 'act-pre-algebra',
    title: 'ACT Math: Pre-Algebra',
    description: 'Master whole numbers, fractions, decimals, percents, ratios, and basic probability for ACT.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Pre-Algebra',
    difficulty: 'Advanced',
    pages: 10,
    isFree: false,
    downloadUrl: '/downloads/act-pre-algebra.pdf',
    thumbnailUrl: 'https://public.readdy.ai/ai/img_res/6601d2015eff3d8f012a22bbb53526ed.jpg'
  },
  {
    id: 'act-elementary-algebra',
    title: 'ACT Math: Elementary Algebra',
    description: 'Practice linear equations, inequalities, polynomials, and factoring for ACT Math.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Elementary Algebra',
    difficulty: 'Advanced',
    pages: 10,
    isFree: false,
    downloadUrl: '/downloads/act-elementary-algebra.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20elementary%20algebra%20worksheet%20with%20linear%20equations%2C%20inequalities%2C%20polynomial%20operations%2C%20factoring%20problems%2C%20official%20ACT%20format%2C%20professional%20test%20design%2C%20clean%20organized%20background&width=400&height=500&seq=actmath02&orientation=portrait'
  },
  {
    id: 'act-intermediate-algebra',
    title: 'ACT Math: Intermediate Algebra',
    description: 'Tackle quadratics, radicals, rational expressions, functions, and exponentials for ACT.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Intermediate Algebra',
    difficulty: 'Advanced',
    pages: 10,
    isFree: false,
    downloadUrl: '/downloads/act-intermediate-algebra.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20intermediate%20algebra%20worksheet%20with%20quadratic%20formula%2C%20radical%20expressions%2C%20rational%20functions%2C%20exponential%20equations%2C%20official%20ACT%20style%20format%2C%20professional%20test%20layout%2C%20clean%20background&width=400&height=500&seq=actmath03&orientation=portrait'
  },
  {
    id: 'act-coordinate-geometry',
    title: 'ACT Math: Coordinate Geometry',
    description: 'Master distance, midpoint, slope, graphing, and coordinate plane concepts for ACT.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Coordinate Geometry',
    difficulty: 'Advanced',
    pages: 10,
    isFree: false,
    downloadUrl: '/downloads/act-coordinate-geometry.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20coordinate%20geometry%20worksheet%20with%20coordinate%20planes%2C%20graphing%20lines%2C%20distance%20formula%2C%20slope%20problems%2C%20circles%20and%20parabolas%2C%20official%20ACT%20format%2C%20professional%20test%20design%2C%20clean%20white%20background&width=400&height=500&seq=actmath04&orientation=portrait'
  },
  {
    id: 'act-plane-geometry',
    title: 'ACT Math: Plane Geometry',
    description: 'Review angles, triangles, circles, area, volume, and geometric proofs for ACT Math.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Plane Geometry',
    difficulty: 'Advanced',
    pages: 10,
    isFree: false,
    downloadUrl: '/downloads/act-plane-geometry.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20plane%20geometry%20worksheet%20with%20triangles%2C%20circles%2C%20angles%2C%20area%20and%20volume%20problems%2C%20geometric%20shapes%20and%20proofs%2C%20official%20ACT%20style%20format%2C%20professional%20test%20layout%2C%20clean%20organized%20background&width=400&height=500&seq=actmath05&orientation=portrait'
  },
  {
    id: 'act-trigonometry',
    title: 'ACT Math: Trigonometry',
    description: 'Practice right triangle trig, unit circle, trig identities, and graphing for ACT.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Trigonometry',
    difficulty: 'Advanced',
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/act-trigonometry.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20trigonometry%20worksheet%20with%20unit%20circle%2C%20SOH-CAH-TOA%2C%20trig%20functions%2C%20right%20triangles%2C%20trig%20identities%2C%20official%20ACT%20format%2C%20professional%20test%20design%2C%20clean%20background&width=400&height=500&seq=actmath06&orientation=portrait'
  },
  {
    id: 'act-math-practice-test',
    title: 'ACT Math: Full Practice Test',
    description: 'Complete 60-question ACT Math practice test covering all six domains with answer explanations.',
    grade: 'ACT Math',
    subject: 'Test Prep',
    topic: 'Full Test',
    difficulty: 'Advanced',
    pages: 18,
    isFree: false,
    downloadUrl: '/downloads/act-math-practice-test.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20full%20math%20practice%20test%20booklet%20cover%20with%20official%20style%20layout%2C%20sixty%20question%20math%20section%2C%20answer%20sheet%20with%20bubbles%20A%20through%20K%2C%20professional%20standardized%20test%20format%2C%20clean%20background&width=400&height=500&seq=actmath07&orientation=portrait'
  },

  // SAT Prep
  {
    id: 'sat-algebra-heart',
    title: 'SAT Math: Heart of Algebra',
    description: 'Master linear equations, inequalities, and systems for the SAT Math section.',
    grade: 'SAT Prep',
    subject: 'Test Prep',
    topic: 'Algebra',
    difficulty: 'Advanced',
    pages: 10,
    isFree: false,
    downloadUrl: '/downloads/sat-algebra-heart.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=SAT%20test%20prep%20worksheet%20with%20official%20style%20math%20problems%2C%20linear%20equations%20and%20systems%2C%20multiple%20choice%20bubbles%2C%20grid%20in%20sections%2C%20professional%20test%20format%2C%20clean%20organized%20layout&width=400&height=500&seq=sat01&orientation=portrait'
  },
  {
    id: 'sat-problem-solving',
    title: 'SAT Math: Problem Solving',
    description: 'Practice data analysis, ratios, percentages, and proportional reasoning for SAT.',
    grade: 'SAT Prep',
    subject: 'Test Prep',
    topic: 'Problem Solving',
    difficulty: 'Advanced',
    pages: 10,
    isFree: false,
    downloadUrl: '/downloads/sat-problem-solving.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=SAT%20problem%20solving%20worksheet%20with%20data%20tables%2C%20graphs%2C%20charts%2C%20percentage%20problems%2C%20ratio%20questions%2C%20official%20SAT%20style%20format%2C%20professional%20test%20design%2C%20clean%20white%20background&width=400&height=500&seq=sat02&orientation=portrait'
  },
  {
    id: 'sat-passport-advanced',
    title: 'SAT Math: Passport to Advanced Math',
    description: 'Tackle quadratics, polynomials, radicals, and exponential functions for SAT.',
    grade: 'SAT Prep',
    subject: 'Test Prep',
    topic: 'Advanced Math',
    difficulty: 'Advanced',
    pages: 10,
    isFree: false,
    downloadUrl: '/downloads/sat-passport-advanced.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=SAT%20advanced%20math%20worksheet%20with%20quadratic%20equations%2C%20polynomial%20functions%2C%20exponential%20graphs%2C%20complex%20expressions%2C%20official%20SAT%20format%2C%20professional%20test%20layout%2C%20clean%20background&width=400&height=500&seq=sat03&orientation=portrait'
  },
  {
    id: 'sat-geometry-trig',
    title: 'SAT Math: Additional Topics',
    description: 'Review geometry, trigonometry, and complex numbers for SAT Math.',
    grade: 'SAT Prep',
    subject: 'Test Prep',
    topic: 'Geometry',
    difficulty: 'Advanced',
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/sat-geometry-trig.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=SAT%20geometry%20and%20trigonometry%20worksheet%20with%20circle%20theorems%2C%20triangle%20problems%2C%20trig%20ratios%2C%20coordinate%20geometry%2C%20official%20SAT%20style%2C%20professional%20test%20format%2C%20clean%20organized%20layout&width=400&height=500&seq=sat04&orientation=portrait'
  },
  {
    id: 'sat-practice-test',
    title: 'SAT Math: Full Practice Test',
    description: 'Complete SAT Math practice test with calculator and no-calculator sections.',
    grade: 'SAT Prep',
    subject: 'Test Prep',
    topic: 'Full Test',
    difficulty: 'Advanced',
    pages: 15,
    isFree: false,
    downloadUrl: '/downloads/sat-practice-test.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=SAT%20full%20practice%20test%20cover%20page%20with%20official%20style%20layout%2C%20test%20booklet%20design%2C%20calculator%20and%20no%20calculator%20sections%2C%20answer%20sheet%20bubbles%2C%20professional%20standardized%20test%20format%2C%20clean%20background&width=400&height=500&seq=sat05&orientation=portrait'
  },

  // ACT Prep (General)
  {
    id: 'act-algebra-functions',
    title: 'ACT Math: Algebra and Functions',
    description: 'Practice algebra, functions, and equations for ACT Math section.',
    grade: 'ACT Prep',
    subject: 'Test Prep',
    topic: 'Algebra',
    difficulty: 'Advanced',
    pages: 10,
    isFree: false,
    downloadUrl: '/downloads/act-algebra-functions.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20test%20prep%20worksheet%20with%20algebra%20problems%2C%20function%20notation%2C%20equations%2C%20official%20ACT%20style%20format%2C%20multiple%20choice%20options%20A%20through%20K%2C%20professional%20test%20layout%2C%20clean%20white%20background&width=400&height=500&seq=act01&orientation=portrait'
  },
  {
    id: 'act-geometry-measurement',
    title: 'ACT Math: Geometry',
    description: 'Master geometry concepts including area, volume, angles, and coordinate geometry for ACT.',
    grade: 'ACT Prep',
    subject: 'Test Prep',
    topic: 'Geometry',
    difficulty: 'Advanced',
    pages: 10,
    isFree: false,
    downloadUrl: '/downloads/act-geometry-measurement.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20geometry%20worksheet%20with%20shapes%2C%20angle%20measurements%2C%20coordinate%20planes%2C%20area%20and%20volume%20problems%2C%20official%20ACT%20format%2C%20professional%20test%20design%2C%20clean%20organized%20background&width=400&height=500&seq=act02&orientation=portrait'
  },
  {
    id: 'act-trig-precalc',
    title: 'ACT Math: Trigonometry',
    description: 'Review trigonometric functions, identities, and applications for ACT Math.',
    grade: 'ACT Prep',
    subject: 'Test Prep',
    topic: 'Trigonometry',
    difficulty: 'Advanced',
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/act-trig-precalc.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20trigonometry%20worksheet%20with%20unit%20circle%2C%20trig%20functions%2C%20right%20triangles%2C%20trig%20identities%2C%20official%20ACT%20style%20format%2C%20professional%20test%20layout%2C%20clean%20background&width=400&height=500&seq=act03&orientation=portrait'
  },
  {
    id: 'act-statistics-probability',
    title: 'ACT Math: Statistics and Probability',
    description: 'Practice data analysis, statistics, and probability for ACT Math section.',
    grade: 'ACT Prep',
    subject: 'Test Prep',
    topic: 'Statistics',
    difficulty: 'Advanced',
    pages: 8,
    isFree: false,
    downloadUrl: '/downloads/act-statistics-probability.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20statistics%20worksheet%20with%20data%20tables%2C%20bar%20graphs%2C%20probability%20problems%2C%20mean%20median%20mode%2C%20official%20ACT%20format%2C%20professional%20test%20design%2C%20clean%20white%20background&width=400&height=500&seq=act04&orientation=portrait'
  },
  {
    id: 'act-practice-test',
    title: 'ACT Math: Full Practice Test',
    description: 'Complete 60-question ACT Math practice test with answer explanations.',
    grade: 'ACT Prep',
    subject: 'Test Prep',
    topic: 'Full Test',
    difficulty: 'Advanced',
    pages: 18,
    isFree: false,
    downloadUrl: '/downloads/act-practice-test.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=ACT%20full%20practice%20test%20booklet%20cover%20with%20official%20style%20layout%2C%20sixty%20question%20math%20section%2C%20answer%20sheet%20with%20bubbles%20A%20through%20K%2C%20professional%20standardized%20test%20format%2C%20clean%20background&width=400&height=500&seq=act05&orientation=portrait'
  }
];